import React, { useCallback, useState } from 'react';
import LightIcon from 'images/icons/light-icon.inline.svg'
import DarkIcon from 'images/icons/dark-icon.inline.svg'
import { switchWrap, lightIcon, darkIcon } from './toggle-styles.module.scss';


const label = 'switch' 
 
const Toggle = () => { 

  const [checked, setChecked] = useState(window.__theme === 'dark');

  const onChange = useCallback(
    e => {
      const isChecked = e.target.checked;
      setChecked(isChecked);
      window.__setPreferredTheme(isChecked ? 'dark' : 'light');
    },
    [setChecked]
  );

  return (
    <label htmlFor={label} className={switchWrap} aria-hidden title="Change theme">
      <input
          tabIndex="-1"
          id={label} 
          type="checkbox" 
          role="switch"  
          checked={checked} 
          onChange={onChange}
          aria-checked={checked}
          aria-labelledby={`label-${label}`}
      />
      <span  className={lightIcon}><LightIcon/></span>
      <span  className={darkIcon}><DarkIcon/></span>

    </label>
  )
};

export default Toggle;